module.exports = __webpack_public_path__ + "./img/635365a98e0504fbca51dff59b0e24bc.png";